module.exports = __webpack_public_path__ + "3a45879485fa21c53bf63e2d09961510.pdf";